import { Context, Controller } from '@hotwired/stimulus';

export default class ActiveCampaignNewslettersSubscriptionsController extends Controller {
  public static values = {
    url: String,
  };

  declare private readonly urlValue: string;
  declare private readonly hasUrlValue: boolean;

  private abortController!: AbortController;

  public constructor(context: Context) {
    super(context);
  }

  public connect(): void {
    this.abortController = new AbortController();

    if (!this.hasUrlValue) {
      return;
    }

    void fetch(this.urlValue, {
      headers: {
        accept: 'application/vnd.opus-safety.newsletters.subscribed.v1+json',
      },
      signal: this.abortController.signal,
    })
      .then((response) => response.json())
      .then((ids: string[]) => {
        // Cancel if already aborted
        if (this.abortController.signal.aborted) {
          return;
        }

        ids.forEach((id) => {
          const input = this.element.querySelector<HTMLInputElement>(
            `input[value="${id}"]`,
          );
          if (input) {
            input.checked = true;
            input.disabled = true;
          }
        });
      });
  }

  public disconnect(): void {
    this.abortController.abort(
      'Disconnected ActiveCampaignNewslettersSubscriptionsController',
    );
  }
}
